import React, { useMemo } from 'react';
import { DashboardPermissionGuard } from '@components';
import { Banner, Subsection, useModalContext } from '@fourthwall/components';
import { AddSubscriptionModal, SubscriptionStorageLabel, UpgradeSubscriptionBanner, useSubscription, useSubscriptionStorageLimits, } from '@modules/Dashboard/modules/Subscriptions';
import * as S from './StorageLimits.styled';
import { StorageLimit } from './component/StorageLimit/StorageLimit';
export const StorageLimits = () => {
    const { open } = useModalContext();
    const { activeSubscription, canUpgradeSubscription, isLoading: isSubscriptionLoading, } = useSubscription();
    const { digitalProductsStorage, productDesignerStorage } = useSubscriptionStorageLimits();
    const isLoading = useMemo(() => !activeSubscription || isSubscriptionLoading, [activeSubscription, isSubscriptionLoading]);
    const shouldShowBanner = useMemo(() => {
        return (!isLoading && (digitalProductsStorage.isLimitReached || digitalProductsStorage.isNearLimit));
    }, [isLoading, digitalProductsStorage]);
    const openAddSubscriptionModal = () => {
        open(AddSubscriptionModal, {
            source: 'settings_plan',
        });
    };
    const renderBanner = () => {
        if (!shouldShowBanner)
            return null;
        const isNearLimit = digitalProductsStorage.isNearLimit;
        if (!canUpgradeSubscription) {
            return (React.createElement(Banner, { appearance: "warning" },
                isNearLimit ? (React.createElement(React.Fragment, null,
                    "You\u2019re close to reaching your",
                    ' ',
                    React.createElement(SubscriptionStorageLabel, { size: digitalProductsStorage.limit }),
                    " storage limit")) : (React.createElement(React.Fragment, null,
                    "You\u2019ve reached your storage limit of",
                    ' ',
                    React.createElement(SubscriptionStorageLabel, { size: digitalProductsStorage.limit }))),
                ". Delete some files or email us at",
                ' ',
                React.createElement("a", { href: "mailto:support@fourthwall.com" }, "contact our support team"),
                " to request a higher storage limit."));
        }
        if (!digitalProductsStorage.topSubscriptionPlanLimit)
            return null;
        return (React.createElement(UpgradeSubscriptionBanner, { source: "settings_plan", onClick: openAddSubscriptionModal },
            isNearLimit ? (React.createElement(React.Fragment, null,
                "You\u2019re close to reaching your",
                ' ',
                React.createElement(SubscriptionStorageLabel, { size: digitalProductsStorage.limit }),
                " storage limit")) : (React.createElement(React.Fragment, null,
                "You\u2019ve reached your storage limit of",
                ' ',
                React.createElement(SubscriptionStorageLabel, { size: digitalProductsStorage.limit }))),
            ". Upgrade to get",
            ' ',
            React.createElement(SubscriptionStorageLabel, { size: digitalProductsStorage.topSubscriptionPlanLimit }),
            " of digital product file limit."));
    };
    if (!digitalProductsStorage.enabled && !productDesignerStorage.enabled) {
        return null;
    }
    return (React.createElement(DashboardPermissionGuard, { permission: "settings.plan.storageLimits" },
        React.createElement(Subsection, { title: "Storage limits" },
            React.createElement(S.Content, null,
                digitalProductsStorage.enabled && (React.createElement(StorageLimit, { title: `Digital product file ${digitalProductsStorage.isUnlimited ? 'usage' : 'limit'}`, currentSize: digitalProductsStorage.usage, maxSize: digitalProductsStorage.limit, isLoading: isLoading })),
                productDesignerStorage.enabled && (React.createElement(StorageLimit, { title: `Product designer file ${productDesignerStorage.isUnlimited ? 'usage' : 'limit'}`, currentSize: productDesignerStorage.usage, maxSize: productDesignerStorage.limit, isLoading: isLoading })),
                renderBanner()))));
};
